import PieBase from './PieBase';

const TYPES_MAP = {
  SU: 'Substance Use',
  MH: 'Mental Health',
  CO: 'Co-Occurring',
};

export default function TypeChart({ chartData }) {
  const data = [];
  const typeCounts = {};

  for (const { alertType } of chartData) {
    if (!(alertType in typeCounts)) {
      typeCounts[alertType] = {
        label: TYPES_MAP[alertType],
        value: 1,
      };
    } else {
      typeCounts[alertType].value += 1;
    }
  }

  for (const count of Object.values(typeCounts)) {
    data.push(count);
  }

  return (
    <PieBase
      title={'Alert Type'}
      data={data}
    />
  );
}
